const header = document.querySelector('sticky-header');
const logo = document.querySelector('.header__heading-logo:not(.logo-dark)');
const logo_dark = document.querySelector('.header__heading-logo.logo-dark');

let lastScrollY = window.scrollY;
let ticking = false;

function updateHeader() {
  const currentScrollY = window.scrollY;

  if (lastScrollY > currentScrollY) {
    if (currentScrollY <= 1) {
      header.classList.remove(COLOR_SCHEME);
      header.classList.add(COLOR_SCHEME_TOP);
      if (!USE_SVG) {
        logo?.classList.add('hidden');
        logo_dark?.classList.remove('hidden');
      }
    } else {
      header.classList.remove(COLOR_SCHEME_TOP);
      header.classList.add(COLOR_SCHEME);
      if (!USE_SVG) {
        logo?.classList.remove('hidden');
        logo_dark?.classList.add('hidden');
      }
    }
  }

  lastScrollY = currentScrollY;
  ticking = false;
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(updateHeader);
    ticking = true;
  }
});
